import { createApi } from '@reduxjs/toolkit/query/react';

import {
  ClientFieldsEndpoints as Endpoints,
  type CreateClientFieldRequest,
  type CreateClientFieldResponse,
  type DeleteClientFieldRequest,
  type DeleteClientFieldResponse,
  type EditClientFieldRequest,
  type EditClientFieldResponse,
  type GetClientFieldByIdRequest,
  type GetClientFieldByIdResponse,
  type GetClientFieldsRequest,
  type GetClientFieldsResponse,
} from '@app/api/ClientFields/types';
import { createApiBaseQuery, Methods } from '@app/api/shared';
import { CLIENT_FIELDS_CHUNK } from '@app/constants';

const CLIENT_FIELDS_TAG = 'ClientFields';

export const clientFieldsApi = createApi({
  reducerPath: 'clientFieldsApi2',
  baseQuery: createApiBaseQuery(CLIENT_FIELDS_CHUNK),
  tagTypes: [CLIENT_FIELDS_TAG],
  endpoints: ({ mutation, query }) => ({
    [Endpoints.GetClientFields]: query<
      GetClientFieldsResponse,
      GetClientFieldsRequest
    >({
      query: (params) => ({
        url: Endpoints.GetClientFields,
        method: Methods.GET,
        params,
      }),
      providesTags: [CLIENT_FIELDS_TAG],
    }),
    [Endpoints.GetClientFieldById]: query<
      GetClientFieldByIdResponse,
      GetClientFieldByIdRequest
    >({
      query: (params) => ({
        url: Endpoints.GetClientFieldById,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.CreateClientField]: mutation<
      CreateClientFieldResponse,
      CreateClientFieldRequest
    >({
      query: ({ data, ...params }) => ({
        url: Endpoints.CreateClientField,
        method: Methods.POST,
        params,
        data,
      }),
      invalidatesTags: [CLIENT_FIELDS_TAG],
    }),
    [Endpoints.EditClientField]: mutation<
      EditClientFieldResponse,
      EditClientFieldRequest
    >({
      query: ({ data, ...params }) => ({
        url: Endpoints.EditClientField,
        method: Methods.PUT,
        params,
        data,
      }),
      invalidatesTags: [CLIENT_FIELDS_TAG],
    }),
    [Endpoints.DeleteClientField]: mutation<
      DeleteClientFieldResponse,
      DeleteClientFieldRequest
    >({
      query: (params) => ({
        url: Endpoints.DeleteClientField,
        method: Methods.DELETE,
        params,
      }),
      invalidatesTags: [CLIENT_FIELDS_TAG],
    }),
  }),
});

export const {
  useGetClientFieldsQuery,
  useLazyGetClientFieldsQuery,
  useGetClientFieldByIdQuery,
  useLazyGetClientFieldByIdQuery,
  useCreateClientFieldMutation,
  useEditClientFieldMutation,
  useDeleteClientFieldMutation,
} = clientFieldsApi;
